/**
 * The running app version (v3.80.0) — read from package.json at build time.
 * CRA allows this one import from outside src/ (UserGuide.js uses the same).
 * Single source of truth: bump package.json and every "You're on vX" /
 * "(Current)" surface follows. Pinned equal to package.json by
 * src/components/ReleaseNotesModal.test.js.
 */
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;
